module.exports = __webpack_public_path__ + "static/media/30MEDubai-The_Opus_Pool.de4701cd.jpg";